module.exports = __webpack_public_path__ + "static/media/JAPAN-Keio.69756c00.png";